import React, { useMemo } from "react";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";
import MultiSelect from "components/ui/multiSelect"; // Importing MultiSelect

const roleOptions = [
  { value: "1", label: "Director" },
  { value: "2", label: "Camera Operator" },
  { value: "3", label: "Audio Engineer" },
  { value: "4", label: "Lighting Technician" },
  { value: "5", label: "Video Editor" },
  { value: "6", label: "Stream Engineer" },
  { value: "7", label: "Production Manager" },
  { value: "8", label: "Graphics Designer" },
  { value: "9", label: "Videographer" },
  { value: "10", label: "Photographers" },
];

const ProfessionalInfoForm = ({ profile = {}, onChange }) => {

  // 1. Convert roleOptions to the format MultiSelect expects (id/name)
  const formattedOptions = useMemo(() =>
    roleOptions.map(opt => ({ id: opt.value, name: opt.label })),
  []);

  // 2. Parse primary_role into an ARRAY of strings
  const normalizedRoleValues = useMemo(() => {
    const rawRole = profile.primary_role;
    if (!rawRole) return [];

    try {
      // Handle JSON string like "[\"1\", \"2\"]"
      if (typeof rawRole === 'string' && rawRole.startsWith('[')) {
        const parsed = JSON.parse(rawRole);
        return Array.isArray(parsed) ? parsed.map(String) : [];
      }
      // Handle case where it might already be an array
      if (Array.isArray(rawRole)) return rawRole.map(String);

      // Handle single string fallback
      return [String(rawRole)];
    } catch (e) {
      console.error("Error parsing roles", e);
      return [];
    }
  }, [profile.primary_role]);

  const handleFieldChange = (fieldName, value) => {
    onChange?.({
      [fieldName]: value,
    });
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-y-8 gap-x-16">
        {/* PRIMARY ROLE (Now Multi-Select) */}
        <div className="flex flex-col gap-2">
          <Label className="font-bold">Primary Roles</Label>
          <MultiSelect
            options={formattedOptions}
            placeholder="Select Roles"
            value={normalizedRoleValues}
            onChange={(val) => handleFieldChange("primary_role", val)}
          />
        </div>

        {/* EXPERIENCE */}
        <div className="flex flex-col gap-2">
          <Label className="font-bold">Years of Experience</Label>
          <Input
            type="number"
            placeholder="Enter years of experience"
            value={profile.years_of_experience ?? ""}
            onChange={(e) => handleFieldChange("years_of_experience", e.target.value)}
          />
        </div>

        {/* HOURLY RATE */}
        <div className="flex flex-col gap-2">
          <Label className="font-bold">Hourly Rate ($)</Label>
          <Input
            placeholder="Enter hourly rate"
            value={profile.hourly_rate ?? ""}
            onChange={(e) => handleFieldChange("hourly_rate", e.target.value)}
          />
        </div>
      </div>

      {/* BIO */}
      <div className="mt-8 flex flex-col gap-2">
        <Label className="font-bold">Bio / About</Label>
        <Textarea
          placeholder="Brief description of expertise and background..."
          value={profile.bio || ""}
          onChange={(e) => handleFieldChange("bio", e.target.value)}
        />
      </div>
    </>
  );
};

export default ProfessionalInfoForm;
